// Stable mount-element ids for the split-panel Cue architecture. The
// panel-root id matches the historical 'wx-copilot-root' so hooks that
// default to that id (e.g. useWxCopilotPageContext) continue to target the
// instance that owns the InternalBridge.
export const CUE_PANEL_ROOT_MOUNT_ID = 'wx-copilot-root';
export const CUE_TRIGGER_MOUNT_ID = 'wx-cue-trigger';
